import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../../conndb";
import Logo from '../asset/Logo.png'
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      return;
    }

    // ✅ Login riuscito → redirect alla home riservata
    navigate("/ges_home");
  };

  return (
    <div className="flex h-screen items-center justify-center bg-[#173341]">
      <form
        onSubmit={handleLogin}
        className="bg-[#5b90ab70] p-6 rounded-2xl shadow-md w-80 text-white"
      >
        <div className="flex justify-center">
          <img src={Logo} className="w-20"></img>
        </div>
        <h2 className="text-xl font-bold mb-4 text-center">Area Riservata</h2>
        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 bg-[#173341] rounded-lg mb-3"
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 bg-[#173341] rounded-lg mb-3"
          required
        />

        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600"
        >
          Login
        </button>
      </form>
    </div>
  );
}
